<app-header></app-header>
<section class="bredcrumb">
  <div class="container">
      <ul class="brd-nav">
          <li> <a [routerLink]="['/']"> Home </a></li>
          <li> Edit Profile</li>
      </ul>
  </div>
</section>
<!--- End of bredcrumb -->

<section class="single-page doctors-detail user-profile-view padd-row">
  <div class="container">
      <form #f="ngForm" class="doctors-edit-main">
      <div class="row">
          <div class="col-lg-4">
              <div class="doc-detail-lft p-0 sidebar">

                  <div class="user-profile-view-left-img doc-detail-box grey-bg mb-4">
                      <img [src]="loginData.profilePicture" alt="image">
                  </div>
                  <div class="doctor-box-top-cnt">
                    <input style="display:none;" (change)="fileChanged($event)" type="file" accept="image/*" #file>
                  <button type="button" id="buttonfileupload"  class="upload-img" (click)="file.click()"> Upload or change your profile image here </button>
              </div>

                  <div class="user-profile-view-left-list doc-detail-box grey-bg p-25-side mb-4">
                      <ul>
                          <li>
                              <img src="assets/images/form-user.png" alt="image">
                              <div class="col-md-12">
                                <label> Name </label>
                                <input type="text" required name="userName" #userName="ngModel" [(ngModel)]="loginData.name" class="form-control" placeholder="Enter Name">
                                <div *ngIf="f.submitted && !userName.valid" class="alert alert-danger" >Name is required</div>
                            </div>
                          </li>
                          <li>
                              <img src="assets/images/phone.png" alt="image">
                              <div class="col-md-12">
                                  <label> Phone No </label>
                                  <input type="text" required name="userPhone" (keypress)="numberOnly($event,null)" #userPhone="ngModel" [(ngModel)]="loginData.phoneNo" class="form-control" placeholder="Enter Phone No">
                                  <div *ngIf="f.submitted && !userPhone.valid" class="alert alert-danger" >Phone is required</div>
                              </div>
                          </li>
                          <li>
                              <img src="assets/images/email.jpg" alt="image">
                              <div class="col-md-12">
                                  <label> Email </label>
                                  <input type="text" required name="userEMail" #userEmail="ngModel" [(ngModel)]="loginData.email" class="form-control" placeholder="Enter Emain Id">
                                  <div *ngIf="f.submitted && !userEmail.valid" class="alert alert-danger" >Email is required</div>
                              </div>
                          </li>
                      </ul>
                  </div>

                  <div class="set-reminder-user doc-detail-box grey-bg p-25-side">
                      <h3> Reminder </h3>

                          <div class="row">
                              <div class="col-md-12">
                                  <label> Name: </label>
                                  <div class="form-group-img">
                                      <input type="text" class="form-control" placeholder="Celia Kennady">
                                      <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                  </div>
                              </div>
                              <div class="col-md-12">
                                  <label> Type: </label>
                                  <div class="form-group-img">
                                      <input type="text" class="form-control" placeholder="Urgent">
                                      <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                  </div>
                              </div>
                              <div class="col-md-12">
                                  <label> Date: </label>
                                  <div class="form-group-img">
                                      <input type="text" class="form-control" placeholder="31-01-19">
                                      <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
                                  </div>
                              </div>
                              <div class="col-md-12">
                                  <label> Time: </label>
                                  <div class="form-group-img">
                                      <input type="text" class="form-control" placeholder="21:10 PM">
                                      <i class="fa fa-clock-o" aria-hidden="true"></i>
                                  </div>
                              </div>
                              <div class="col-md-12">
                                  <input type="submit" class="btn-style" value="Set Reminder">
                              </div>
                          </div>

                  </div>

              </div>
          </div>

          <div class="col-lg-8">
              <div class="white-bg-shadow doc-chat-right-side">
                  <div class="doc-chat-header">
                      <h3> ABout {{ loginData.name }} </h3>
                  </div>
                  <div class="user-profile-right">
                      <div class="doc-detail-cnt btm-line">
                          <p> {{ loginData.about }}. </p>
                      </div>
                      <div class="doc-detail-edu doc-detail-cnt btm-line">
                          <h3> Education & Credentials </h3>
                          <h4> Education </h4>
                          <p class="mb-0"> Columiba School - Columbia University </p>
                          <p class="mb-4"> Lutheran Medical Center (Residency) </p>
                          <h4> Languages Spoken </h4>
                          <p class="mb-0"> {{ loginData.languages.join(',') }}</p>
                      </div>
                      <div class="doc-detail-edu doc-detail-cnt btm-line">
                          <h3> Contact Information </h3>
                          <div class="row no-gutters">
                              <div class="col-md-6">
                                  <p class="mb-0"><strong> Gender: </strong> {{ loginData.gender }} </p>
                              </div>
                              <div class="col-md-6">
                                  <p class="mb-0"> <strong> Date of Birth: </strong> {{ loginData.dob }} </p>
                              </div>
                              <div class="col-md-6 mb-0">
                                  <p class="mb-0"> <strong> Blood Group: </strong>{{ loginData.bloodGroup }} </p>
                              </div>
                          </div>
                      </div>
                      <div class="doc-detail-edu doc-detail-cnt btm-line">
                          <h3> Address </h3>
                          <div class="row no-gutters">
                              <div class="col-md-12">
                                  <p class="mb-0"><strong> House No. Street Name/ Area: </strong> {{ loginData.address }} </p>
                              </div>
                              <div class="col-md-6">
                                  <p class="mb-0"> <strong> City: </strong> {{ loginData.city }} </p>
                              </div>
                              <div class="col-md-6">
                                  <p class="mb-0"> <strong> State: </strong> {{ loginData.state }} </p>
                              </div>
                              <div class="col-md-6 mb-0">
                                  <p class="mb-0"> <strong> Country: </strong> {{ loginData.country }} </p>
                              </div>
                              <div class="col-md-6 mb-0">
                                  <p class="mb-0"> <strong> Pincode: </strong> 160019 </p>
                              </div>
                          </div>
                      </div>
                      <div class="upload-list-pharmacy doc-detail-cnt">
                          <h3> Upload List </h3>
                          <div class="row">
                              <div class="col-md-6">
                                  <div class="upload-list-lft">
                                      <input type="file" name="img" multiple>
                                      <img src="assets/images/upload-file.png" alt="image">
                                      <h3> Drag & drop </h3>
                                      <h4> or <span> Browse </span> your files </h4>
                                  </div>
                              </div>
                              <div class="col-md-6">
                                  <div class="upload-list-rght">
                                      <div class="upload-list-files">
                                          <ul>
                                              <li>
                                                  <div class="upload-list-file-box">
                                                      <img src="assets/images/file.png" alt="image">
                                                      <h4 class="clearfix"> Medicine List 1 <i class="fa fa-times" aria-hidden="true"></i> </h4>
                                                      <p> 12 Mb </p>
                                                      <div class="progress">
                                                          <div class="progress-bar" style="width:70%"></div>
                                                      </div>
                                                  </div>
                                              </li>
                                              <li>
                                                  <div class="upload-list-file-box">
                                                      <img src="assets/images/file.png" alt="image">
                                                      <h4 class="clearfix"> Medicine List 2 <i class="fa fa-times" aria-hidden="true"></i> </h4>
                                                      <p> 12 Mb </p>
                                                      <div class="progress">
                                                          <div class="progress-bar" style="width:40%"></div>
                                                      </div>
                                                  </div>
                                              </li>
                                          </ul>
                                      </div>
                                      <div class="upload-list-btm-btns text-right">
                                          <a href="javascript://" class="btn-style btn-style-border"> Cancel </a>
                                          <a href="javascript://" class="btn-style"> Upload </a>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      </form>
  </div>
</section>
<!-- End of doctors-detail -->
